// import marker from '/assets/images/svg/blue_marker.svg';
import { set } from 'lodash';
import { ImageAnnotation } from './ImageAnnotation.js';
import { clear } from 'toastr';
export class ImageAnnotator extends HTMLElement {
    constructor() {
        super();
    }


    connectedCallback() {
        this.init();
    }

    init() {
        this.loadEventHandlers();
    }

    loadEventHandlers() {
        const vCanvas = this.closest('.vetology_canvas');

        // listen for hide/show notifications
        const hideShowSwitch = document.querySelector('on-off-switch');
        hideShowSwitch.addEventListener('on-off-switch-changed-state', this.onHideShowClick.bind(this));

        // listen for image loaded
        vCanvas.addEventListener('vetology-image-loaded', this.onImageLoaded.bind(this));

        // listen for annotation link click events
        document.addEventListener('annotation-link-click-event', this.onAnnotationLinkClick.bind(this));

    }

    onHideShowClick(event) {
        const canvas = this.closest('.vetology_canvas');
        const annotations = canvas.querySelectorAll('image-annotation');
        annotations.forEach(annotation => {
            if (event.detail.state === 'on') {
                annotation.style.display = 'block';
            } else {
                const transitionEndHandler = () => {
                    annotation.style
                    annotation.removeEventListener('transitionend', transitionEndHandler);
                };
                annotation.addEventListener('transitionend', transitionEndHandler);
            }
            setTimeout(() => {
                annotation.style.opacity = event.detail.state === 'on' ? 1 : 0;
            }, 100);
        });
    }

    onImageLoaded(event) {
        this.clearCurrentAnnotations();
        this.addAnnotations(event.detail.image, event.detail.annotations ?? []);
    }

    clearCurrentAnnotations() 
    {
        const vCanvas = document.querySelector('.vetology_canvas');
        const svgs = document.querySelectorAll('image-annotation');
        svgs.forEach(svg => {
            vCanvas.removeChild(svg);
        });

    }


    addAnnotations(image, annotations = []) 
    {
        const imageID = image.imageId.replace('vetology:', '');
        const vCanvas = document.querySelector('.vetology_canvas');
        const $formData = new FormData();
        $formData.append('image_id', imageID);

        if(annotations.length > 0) {
            let index = 0;
            setTimeout(() => {
                annotations.forEach(annotation => {
                    const annotationElem = new ImageAnnotation(annotation, index++);
                    vCanvas.appendChild(annotationElem);
                });
            }, 500);
        } else {
            fetch('/patient-manager/get-image-annotations?' + new URLSearchParams($formData), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            }).then(response => {
                if (!response.ok) {
                    console.error(response);
                    throw new Error('Network response was not ok');
                }
                return response.json();
            }).then(data => {
                const onOffSwitch = document.querySelector('.marker-switch-container');
                if (data.length === 0) {
                    // hide the annotations switch
                    onOffSwitch.style.opacity = 0;
                    return;
                }

                const studySelector = document.querySelector('.study_series_selector:not(.hide)');
                const mutationObserver = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                        if (mutation.type === 'attributes' && mutation.target.classList.contains('study_series_selector')) {
                            // these are the elements we're observing.  Is the 'hide' class removed?
                            if (mutation.oldValue.includes('hide') && !mutation.target.classList.contains('hide')) {
                                // We're done
                                mutationObserver.disconnect();
                                clearTimeout(timeout);
                                this.addAnnotationsFromData(data);
                            }
                        }
                    });
                });

               if (!studySelector) {
                    // wait until we are sure that the elements are loaded
                    let timeout = null;
                    const seriesSelector = document.querySelector('#series_selector');
                    mutationObserver.observe(seriesSelector, {
                        attributes: true,
                        attributeOldValue: true,
                        subtree: true,
                        attributeFilter: ['class']
                    });
                    timeout = setTimeout(() => {
                        mutationObserver.disconnect();
                    }, 15000);

                } else {
                    this.addAnnotationsFromData(data);
                }
            });
        }
    }

    addAnnotationsFromData(data)
    {
        const vCanvas = document.querySelector('.vetology_canvas');
        const studySelector = document.querySelector('.study_series_selector:not(.hide)');
        const selectedImageThumb = studySelector.querySelector('.series_loader_iv.active_series');

        if (!selectedImageThumb || selectedImageThumb.dataset.image_id != data[0].image_id) {
            return;
        }

        // show the annotations switch
        const onOffSwitch = document.querySelector('on-off-switch input');
        const annotationsVisible = onOffSwitch.checked;
        onOffSwitch.style.opacity = 1;
        let index = 0;
        data.forEach(annotation => {
            const annotationElem = new ImageAnnotation(annotation, index++);
            if (!annotationsVisible) {
                annotationElem.style.opacity = 0;
                annotationElem.style.display = 'none';
            }
            vCanvas.appendChild(annotationElem);
        });
      
    }

    onAnnotationLinkClick(event) {
        // determine the image ID and annotation number
        const imageID = event.detail.image_id;
        const annotationNumber = event.detail.annotation_number;
        // if the corresponding image is not being shown, switch to it
        const seriesSelector = document.querySelector('.study_series_selector:not(.hide)');
        const currentImage = seriesSelector.querySelector('.interface_image_viewer.series_loader_iv.active_series');
        if (!currentImage || (currentImage && currentImage.dataset.image_id !== imageID)) {
            const linkImageContainer = seriesSelector.querySelector('.interface_image_viewer.series_loader_iv[data-image_id="' + imageID + '"]');
            if (linkImageContainer) {
                const seriesActivator = linkImageContainer.querySelector('.series_activator');
                if (seriesActivator) {
                    seriesActivator.click();
                }
            }
        }

        for (const annotation of event.detail.annotations) {        
            this.flashAnnotationsWhenExists(imageID, annotation.marker_number);
        }

    }

    flashAnnotationsWhenExists(imageID, annotationNumber) {
        const canvas = document.querySelector('.vetology_canvas');
        const annotations = canvas.querySelectorAll('image-annotation[data-image_id="' + imageID + '"][data-marker_number="' + annotationNumber + '"]');

        if (annotations.length > 0) {
            annotations.forEach(annotation => {
                annotation.flash();
            });
        } else {
            const observer = new MutationObserver((mutationsList, observer) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        const annotations = canvas.querySelectorAll('image-annotation[data-image_id="' + imageID + '"][data-marker_number="' + annotationNumber + '"]');
                        if (annotations.length > 0) {
                            clearTimeout(timeout);
                            annotations.forEach(annotation => {
                                annotation.flash();
                            });
                            observer.disconnect();
                        }
                    }
                }
            });

            observer.observe(canvas, { childList: true });
            let timeout = setTimeout(() => {
                observer.disconnect();
            }, 15000);
        }


    }

}

customElements.define('image-annotator', ImageAnnotator);
